<div *ngIf="reportType == 'Briefly-OfficerCredit'">
  <div class="container-fluid" id="print-section"
       style="padding: 24px; font-family: 'Segoe UI', sans-serif; margin: 0 auto; width: 98%;">
       
    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1.5px solid #666;">
      <thead>
        <tr>
          <th colspan="1" style="padding: 8px; border: 1.5px solid #666;">Vivek Saptahik</th>
          <th colspan="4" style="padding: 8px; border: 1.5px solid #666; text-align: center;">
            Issue Seller Credit Note Register
          </th>
          <th colspan="3" style="padding: 8px; border: 1.5px solid #666; text-align: right;">
            Date: {{ currentDate | date:'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th colspan="2" style="padding: 6px; border: 1.5px solid #666;">Datewise</th>
          <th colspan="2" style="padding: 6px; border: 1.5px solid #666;">Briefly Officer</th>
          <th colspan="1" style="padding: 6px; border: 1.5px solid #666;">
            Date From {{startDate}} To {{endDate}}
          </th>
          <th colspan="3" style="padding: 6px; border: 1.5px solid #666;">Page No</th>
        </tr>
        <tr>
          <th style="padding: 6px; border: 1.5px solid #666;">Credit Note No.</th>
          <th style="padding: 6px; border: 1.5px solid #666;">CR Date</th>
          <th style="padding: 6px; border: 1.5px solid #666;">Issue Seller Name</th>
          <th style="padding: 6px; border: 1.5px solid #666;">Representative Name</th>
          <th style="padding: 6px; border: 1.5px solid #666;">Office Representative Name</th>
          <th colspan="2" style="padding: 6px; border: 1.5px solid #666; text-align: center;">Credit Note Amount</th>
          <th style="padding: 6px; border: 1.5px solid #666; text-align: center;">Total Credit<br>Amount</th>
        </tr>
        <tr>
          <th colspan="5" style="border: 1.5px solid #666;"></th>
          <th style="text-align: center; padding: 6px; border: 1.5px solid #666;">अंक परत</th>
          <th style="text-align: center; padding: 6px; border: 1.5px solid #666;">अंक गहाळ/खराब</th>
          <th style="border: 1.5px solid #666;"></th>
        </tr>
      </thead>

      <tbody *ngFor="let data of CreditNoteVFormBeans; let i = index">
        <tr>
          <td colspan="2"
              style="font-weight: bold; font-size: 15px; padding: 6px; background: #f9f9f9; border: 1.5px solid #666;">
            Office Representative
          </td>
          <td colspan="1"
              style="font-weight: bold; font-size: 15px; padding: 6px; border: 1.5px solid #666;">
            {{ data.office_rep }}
          </td>
          <td colspan="4" style="padding: 6px; border: 1.5px solid #666;"></td>
        </tr>

        <tr *ngFor="let data1 of data.rep_data">
          <td style="padding: 6px; border: 1.5px solid #666;">{{ data1.credit_note_no }}</td>
          <td style="padding: 6px; border: 1.5px solid #666;">{{ data1.voc_date }}</td>
          <td style="padding: 6px; border: 1.5px solid #666;">{{ data1.issue_Seller_Name }}</td>
          <td style="padding: 6px; border: 1.5px solid #666;">{{ data1.rep_name }}</td>
          <td style="padding: 6px; border: 1.5px solid #666;">{{ data.office_rep }}</td>
          <td style="text-align: end; padding: 6px; border: 1.5px solid #666;">{{ data1.tds_amt }}</td>
          <td style="text-align: end; padding: 6px; border: 1.5px solid #666;">{{ data1.other_credit_amt }}</td>
          <td style="text-align: end; padding: 6px; border: 1.5px solid #666;">{{ data1.credit_amt }}</td>
        </tr>

        <tr>
          <td colspan="5" style="font-weight: bold; text-align: end; padding: 6px; border: 1.5px solid #666;">Total:</td>
          <td style="font-weight: bold; text-align: end; padding: 6px; border: 1.5px solid #666;">{{ data.tds_amt }}</td>
          <td style="font-weight: bold; text-align: end; padding: 6px; border: 1.5px solid #666;">{{ data.other_credit_amt }}</td>
          <td style="font-weight: bold; text-align: end; padding: 6px; border: 1.5px solid #666;">{{ data.total }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="5" style="text-align: end; font-weight: bold; padding: 8px; border: 1.5px solid #666;">Grand Total:</td>
          <td style="text-align: end; font-weight: bold; padding: 8px; border: 1.5px solid #666;">
            {{ CreditadvtOffBrieflyTotalTds }}
          </td>
          <td style="text-align: end; font-weight: bold; padding: 8px; border: 1.5px solid #666;">
            {{ CreditadvtOffBrieflyTotalOther }}
          </td>
          <td style="text-align: end; font-weight: bold; padding: 8px; border: 1.5px solid #666;">
            {{ CreditadvtOffBrieflyTotal }}
          </td>
        </tr>
      </tfoot>
    </table>

    <!-- Action Buttons -->
    <div style="display: flex; justify-content: flex-end; gap: 16px; margin-top: 24px; margin-right: 10%;">
      <button class="noPrint" mat-raised-button color="primary" (click)="exportExcel('Contract_InDetails_Report')">
        ExportOff
      </button>
      <button class="noPrint" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
        Print
      </button>
      <button class="noPrint" mat-button mat-dialog-close>Close</button>
    </div>
  </div>
</div>
